var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReset = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256,85.4c-49.9,0-94.9,22-125.8,56.9h41.4c15.6,0,28.1,12.7,28.1,28.4s-12.6,28.4-28.1,28.4H59 c-15.6,0-28.1-12.7-28.1-28.4V56.9c0-15.7,12.6-28.4,28.1-28.4s28.1,12.7,28.1,28.4v48.6c41.2-47.2,101.6-77,168.8-77 c124.3,0,225.1,101.8,225.1,227.5S380.3,483.5,256,483.5c-76.5,0-144.1-38.6-184.7-97.5c-8.9-12.9-5.8-30.6,6.9-39.6 c12.8-9.1,30.2-5.9,39.2,7c30.6,44.3,81.3,73.1,138.6,73.1c93.2,0,168.8-76.4,168.8-170.6S349.2,85.4,256,85.4z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReset);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Reset.f7098abd8b319c90fea141589cbc3c27.svg";